import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Grid, Typography } from "@mui/material";
import DataTable from "../../../Components/Table/Table";
import DropDown from "../../../Components/DropDown/DropDown";
import SearchBar from "../../../Components/SearchBar/SearchBar";
import AddButton from "../../../Components/AddButton/AddButton";
import Paginations from "../../../Components/Pagination/Pagination";
import hospitalImage from "./../../../Assets/Hospital/mykare-hospital.png";
import useDoctor from "./useDoctor";
import DoctorPopUp from "./DoctorPopup";
import { checkPermission } from "../../../Utils/Permissions";

function Doctors({ isModal }) {
  const navigate = useNavigate();
  const handleOpenPopUp = (data) => {
    navigate("/doctorAddPage", { state: { id: data?.id, isLive: "live" } });
  };
  const tableHeader = [
    {
      id: 1,
      headText1: "Doctor Name",
      headText2: "Departments",
      headText3: "Approval",
      headText4: "Status",
      headText5: "",
      headText6: "Hospital",
    },
  ];

  const {
    doctorData,
    page,
    setPage,
    handleApprovePopup,
    handleStatusPopup,
    modal,
    locations,
    setModal,
    checkedItems,
    setCheckedItems,
    flaggedItems,
    handleDelete,
    departments,
    setFilter,
    platform,
    hospital,
  } = useDoctor();

  const status = [
    {
      name: "Approved",
      value: "APPROVED",
    },
    {
      name: "Pending",
      value: "PENDING",
    },
  ];

  return (
    <Grid
      sx={{
        width: "77%",
        height: "98vh",
        padding: "0px 25px",
      }}
    >
      <DoctorPopUp
        setOpenModal={setModal}
        openModal={modal.isOpen}
        data={modal}
      />
      <Grid
        sx={{
          width: "100%",
          height: "100%",
          backgroundColor: "#f9fbfc",
          borderRadius: "15px",
          padding: "20px",
        }}
      >
        <Grid
          md={12}
          sx={{ height: "80px" }}
          container
          justifyContent="space-between"
          alignItems={"center"}
        >
          <Grid item lg={1.3}>
            <Typography
              style={{ color: "black", fontWeight: "600", fontSize: "20px" }}
            >
              Doctors
            </Typography>
          </Grid>

          <Grid
            flexWrap="wrap"
            container
            item
            md={10}
            justifyContent="space-between"
          >
            {/* <Grid item lg={1.9}>
            <DropDown
              placeHolder="Select Insurance"
              viewHeight={"40px"}
              borderRadius={"50px"}
              bgColor="#ecf1f5"
            />
          </Grid> */}
          </Grid>
        </Grid>
        <Grid
          md={12}
          marginY={2}
          container
          justifyContent="space-between"
          alignItems={"center"}
        >
          <Grid item>
            <DropDown
              placeHolder="Status"
              viewHeight={"40px"}
              borderRadius={"8px"}
              border={"1px solid #DFE5EE"}
              bgColor="#FFFFFF"
              handleSelected={(e, value) => {
                setFilter((s) => ({ ...s, approved: value?.value }));
              }}
              data={status}
            />
          </Grid>
          <Grid ml={2} item>
            <SearchBar
              width={250}
              placeHolder={"Search Doctor..."}
              onChagevalue={(e) =>
                setFilter((s) => ({ ...s, keyword: e.target.value }))
              }
            />
          </Grid>
          <Grid ml={2} item>
            <DropDown
              placeHolder="Select City"
              viewHeight={"40px"}
              borderRadius={"8px"}
              border={"1px solid #DFE5EE"}
              bgColor="#FFFFFF"
              handleSelected={(e, value) =>
                setFilter((s) => ({ ...s, locationId: value?.id }))
              }
              data={locations}
            />
          </Grid>
          <Grid ml={2} item>
            <DropDown
              placeHolder="Platform"
              viewHeight={"40px"}
              borderRadius={"8px"}
              border={"1px solid #DFE5EE"}
              bgColor="#FFFFFF"
              handleSelected={(e, value) => {
                setFilter((s) => ({ ...s, platformId: value?.id }));
              }}
              data={platform}
            />
          </Grid>

          <Grid ml={2} item>
            <DropDown
              placeHolder="Select Category"
              viewHeight={"40px"}
              borderRadius={"8px"}
              border={"1px solid #DFE5EE"}
              bgColor="#FFFFFF"
              data={Array.isArray(departments) ? departments : []}
              handleSelected={(e, value) =>
                setFilter((s) => ({ ...s, departmentId: value?.id }))
              }
            />
          </Grid>
          <Grid ml={2} item>
            <DropDown
              placeHolder="Select Hospital"
              viewHeight={"40px"}
              borderRadius={"8px"}
              border={"1px solid #DFE5EE"}
              bgColor="#FFFFFF"
              data={hospital}
              handleSelected={(e, value) =>
                setFilter((s) => ({ ...s, centerId: value?.id }))
              }
            />
          </Grid>
          <Grid item>
            {checkPermission("DB_DOCTOR_DETAILS_EDIT") && (
              <AddButton
                labelName={"Add New"}
                width={"130px"}
                onClick={handleOpenPopUp}
                viewHeight={"40px"}
                borderRadius={"50px"}
              />
            )}
          </Grid>
        </Grid>
        <DataTable
          isModal={isModal}
          tableHeader={tableHeader}
          data={doctorData.professionals}
          handleEdit={handleOpenPopUp}
          onClick={handleOpenPopUp}
          handleCheckboxChange={handleApprovePopup}
          handleFlaggChange={handleStatusPopup}
          checkedItems={checkedItems}
          flaggedItems={flaggedItems}
          handleDelete={handleDelete}
          isDelete={checkPermission("DB_DOCTOR_DELETE")}
          isStatus={checkPermission("DB_DOCTOR_STATUS")}
          isApproval={checkPermission("DB_DOCTOR_APPROVAL")}
          isEdit={true}
        />
        <Grid
          sx={{ height: "88px", width: "100%" }}
          container
          justifyContent={"center"}
          alignItems={"center"}
        >
          <Paginations
            page={page}
            count={
              doctorData?.count <= 10 ? 1 : Math.ceil(doctorData?.count / 10)
            }
            paginationData={setPage}
          />
        </Grid>
      </Grid>
    </Grid>
  );
}

export default Doctors;
